import { ReactNode } from "react";
import { t } from "@lingui/core/macro";
import {
  GLOBAL_ROLES,
  ROOT_DOMAIN,
  translateRoleName,
  useUserRoles,
} from "_/data/rbac";

import * as S from "./styled";
import { Org } from "_/data/orgs";
import { User } from "_/data/users";

export function Roles({
  user,
  org,
  showGlobalRoles,
}: {
  user: User;
  org: Org;
  showGlobalRoles: boolean;
}): ReactNode {
  const { data: orgDomainRoles } = useUserRoles(user.id, org.domainId, true);
  const { data: rootDomainRoles } = useUserRoles(user.id, ROOT_DOMAIN, true);

  if (orgDomainRoles === undefined || rootDomainRoles === undefined) {
    return null;
  }

  const localRolesTranslated = orgDomainRoles
    .filter(
      (dr) =>
        // If `organization_admin` role exists, do not display the `member` role
        !(
          dr.role === "member" &&
          orgDomainRoles.some((innerDr) =>
            ["organization_admin", "owner"].includes(innerDr.role)
          )
        )
    )
    .map((dr) => ({
      label: translateRoleName(dr.role),
      invalidGlobalRole: GLOBAL_ROLES.includes(dr.role),
    }));

  const globalRolesTranslated = showGlobalRoles
    ? rootDomainRoles.map((dr) => ({
        label: `${translateRoleName(dr.role)} (${t`common.global`})`,
        invalidGlobalRole: false,
      }))
    : [];

  return (
    <S.RolesContainer>
      {[...localRolesTranslated, ...globalRolesTranslated].map(
        (role, i, arr) => (
          <S.RoleItem key={i} $invalidGlobalRole={role.invalidGlobalRole}>
            {role.label}
            {i < arr.length - 1 ? "," : ""}
          </S.RoleItem>
        )
      )}
    </S.RolesContainer>
  );
}
